<template>
  <div class="nav-bar">
    <div class="left">
      <span class="back" @click="exitClick" v-if="!isback && !isExam && isShowBackIcon">
        <slot name="left-icon"></slot>
      </span>
      <span class="back" @click="examBack" v-else-if="isExam && isShowBackIcon">
        <slot name="left-icon"></slot>
      </span>
      <span class="back" @click="backClick" v-else-if="isShowBackIcon">
        <slot name="left-icon"></slot>
      </span>
      <span class="back" @click="loginOout" v-else-if="isLogout">
        <slot name="left-icon"></slot>
      </span>
    </div>
    <div class="center nowrap">
      <slot name="center"></slot>
    </div>
    <div class="right" :style="{ width: rightWidth }">
      <span class="right-tool">
        <slot name="right"></slot>
      </span>
    </div>
  </div>
</template>

<script>
import store from "../../store/index";
// 引入loading
import "components/common/loading/index.css";
import { loading } from "components/common/loading/index";
export default {
  name: "NavBar",
  props: {
    backPath: {
      type: String,
      default: "/index",
    },
    rightWidth: {
      type: String,
      default: "16vw",
    },
    isback: {
      type: Boolean,
      default: true,
    },
    isExam: {
      type: Boolean,
      default: false,
    },
    // isBackNow: {
    //   type: Boolean,
    //   default: false,
    // },
    isShowBackIcon: {
      type: Boolean,
      default: true,
    },
    // 维修端-退出登录
    isLogout: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    // isBackNow() {
    //   this.examBack();
    // },
    backPath(newVal) {
      console.log(this.backPath);
      this.backPath = newVal;
    },
  },
  methods: {
    //返回history
    backClick() {
      this.$router.back(this.backPath);
    },
    examBack() {
      if (1) {
        this.$router.push({ path: this.backPath });
      }
    },
    // 退出操作
    exitClick() {
      this.$emit("exit-click");
      // alert("222");
    },
    //退出登录 --维修端使用
    loginOout() {
      localStorage.removeItem("redirectURL");
      store.commit("saveTokenStorage", "");
      store.commit("saveUserInfoStorage", "");
      loading.show("退出登录");
      // alert("111");
      var type = localStorage.getItem("port") || "";
      setTimeout(() => {
        loading.hide();
        console.log(type, "类型");
        // alert(type, "111");
        if (type == "grant_type_admin") {
          localStorage.clear();
          // alert("登录");
          this.$router.push("/MaintainAdminLogin");
          return;
        }
        localStorage.clear();
        this.$router.push({ path: "/login" });
      }, 1000);
    },
  },
};
</script>

<style scoped>
.nav-bar {
  display: flex;
  height: 96px;
  line-height: 96px;
  background-color: #5391ff;
  color: #fff;
  z-index: 9999;
}
.left {
  width: 120px;
}
.right {
  text-align: center;
  width: 120px;
}
.center {
  flex: 1;
  font-size: 32px;
  text-align: center;
}
.back {
  width: 44px;
  height: 44px;
  margin-left: 40px;
  margin-top: 22px;
}
.right-tool {
  margin-right: 28px;
  line-height: 88px;
  display: block;
  text-align: right;
}
</style>
